export default defineNuxtPlugin(async (nuxtApp) => {
  const { $cookieStore } = nuxtApp.vueApp.config.globalProperties
  const { authenticated, login, logout } = useAuth()
  const isoFetch = useRequestFetch()

  const authCookies = $cookieStore.getAuthCookies('kebab')
  // there is no way an authenticated user has no authentication cookies
  if (authenticated.value && !authCookies) {
    // first try to refresh the credentials with the long-lived/persistent/http-only cookie
    const res = await isoFetch('/api/auth/refresh').catch(() => {})
    if (res?.ok) {
      const { 'access-token': accessToken, client, uid } = res.credentials
      $cookieStore.setAuthCookies(accessToken, client, uid)
      await login(res.data)
    } else {
      await logout()
    }
  }
})
